import React from 'react'
import styles from './ImageSquare.module.scss'
import cl from 'classnames'
import { ImageSquareProps } from './ImageSquare.types'
import { IconImage } from 'assets'

const ImageSquareComponent = (props: ImageSquareProps) => {
  const {
    width = 23.8,
    showBorder,
    className,
    style,
    alt,
    src,
    ...rest
  } = props

  if (!src) {
    return (
      <div
        className={cl(styles.image, styles.noImageContainer, className)}
        style={{
          width,
          height: width
        }}
      >
        <IconImage />
      </div>
    )
  }

  return (
    <img
      className={cl(styles.image, {
        [styles.border]: showBorder
      }, className)}
      width={width}
      height={width}
      alt={alt}
      src={src}
      style={{
        width: width,
        minWidth: width,
        maxWidth: width,
        height: width,
        minHeight: width,
        maxHeight: width,
        ...style
      }}
      {...rest}
    />
  )
}

const ImageSquare = ImageSquareComponent
export { ImageSquare }
